(function ($, Drupal, drupalSettings) {
  "use strict";

  function isOverflown(element) {
    return (
      element.scrollHeight > element.clientHeight ||
      element.scrollWidth > element.clientWidth
    );
  }

  function sliderButtonsOverflow(container, buttons) {
    if (isOverflown(container)) {
      buttons.style.display = "flex";
    }
    $(window).resize(function () {
      if (isOverflown(container)) {
        buttons.style.display = "flex";
      } else {
        buttons.style.display = "none";
      }
    });
  }

  function isIos() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  Theme.all = function (common, options) {
    // Héritage
    this.common = common;

    // Selecteurs
    this.selectors = {
      // EXEMPLES : Data,Hover; Focus...
    };

    // Éléments
    this.elements = {
      html: $("html"),
      body: $("body"),
      blockGalery: $(".paragraph--type--block-galery .galery--content"),
      blockSlider: $(".paragraph--type--block-slider"),
      blockTestimonials: $(".block-testimonials--content"),
    };

    // Variables
    this.toggleMenu = undefined;
    this.rellax = undefined;
    this.fixer = undefined;
  };

  Theme.all.prototype = {
    init: function () {
      this.initLazyLoad();
      this.initMenuMain();
      this.initMenuLanguage();
      this.initHeaderSticky();
      this.initContextualLinks();
      this.initBlockGalery();
      this.initBlockSlider();
      this.initBlockSliderDouble();
      this.initBlockSliderProjects();
      this.initBlockSliderPress();
      this.initBlockSliderSocial();
      this.initListCards();
      this.initListRse();
      this.initFrise();
      this.initPushSimple();
      this.initKeyNumbersPush();
      this.initBlockTestimonials();
      this.initBlockTabs();
      this.initBlockFaq();
      this.initBlockWebform();
      this.initBlockVideo();
      this.initBlockReinssurance();
      this.initBlockTimeline();
      this.initForm();
      this.initPageListProjects();
      this.initPageListPress();
      this.initPageListJobs();
      this.initBlockCitationImgPush();
      this.initSlidersForMobile(
        ".view-display-latest-news .view-list--wrapper"
      );

      // optionnel (désactivé) :
      // this.initEffectsOnScroll();
    },

    load: function () {
      console.log("load");

      this.initSlidersForMobile();

    },
    autoload: function (options) {
      console.log("autoload");
    },

    /**
     * Lazy load
     */
    initLazyLoad: function () {
      var ll = new LazyLoad({
        threshold: 0,
        callback_loaded: function (element) {
          // si l'image fait partie d'un bloc galerie : actualisation
          if (element.closest(".paragraph--type--block-galery")) {
            var all = Drupal.Theme.load("all");
            all.initBlockGalery();
          }
        },
      });
    },

    /**
     * Block Menu Main
     */
    initMenuMain: function () {
      /** Menu desktop **/
      $("body").on(
        "mouseover touch focus",
        "#block-menu-main .level0--link",
        function (e) {
          e.preventDefault();

          let level0Item = $(this).closest(".level0--item");

          if (!level0Item.hasClass("hover")) {
            $(this)
              .closest(".level0")
              .find(".level0--item.hover")
              .removeClass("hover");
            //level0Item.removeClass('inactive').addClass('hover');
            //$(this).closest('.level0').find('.level0--item:not(.hover)').addClass('inactive');
            level0Item.addClass("hover");

            // si texte du menu en blanc : on le change en noir
            if ($(".header-site").hasClass("with-text-white")) {
              $(".header-site")
                .removeClass("with-text-white")
                .addClass("had-text-white");
            }
          }
        }
      );
      $("body").on("mouseover touch", function (e) {
        if (!e.target.closest("#block-menu-main")) {
          if ($("#block-menu-main .level0--item.hover").length) {
            setTimeout(function () {
              //$('#block-menu-main .level0--item').removeClass('hover').removeClass('inactive');
              $("#block-menu-main .level0--item").removeClass("hover");

              // si texte du menu était en blanc : on le remet en blanc
              if ($(".header-site").hasClass("had-text-white")) {
                $(".header-site")
                  .removeClass("had-text-white")
                  .addClass("with-text-white");
              }
            }, 100);
          }
        }
      });

      /** Menu mobile **/
      /* construction du menu mobile */
      $("#block-menu-main").after(
        $("#block-menu-main").clone().attr("id", "block-menu-main-mobile")
      );

      // suppression des spans en trop
      $("#block-menu-main-mobile .megamenu-header").remove();
      $("#block-menu-main-mobile .megamenu-push").remove();
      $(
        "#block-menu-main-mobile .menu-dropdown > .menu-dropdown--wrapper"
      ).unwrap();
      $("#block-menu-main-mobile .menu-dropdown--wrapper > ul").unwrap();
      //$("#block-menu-main-mobile .level0--link > span").unwrap();
      //$("#block-menu-main-mobile .level1--link > span").unwrap();
      //$("#block-menu-main-mobile .level2--link > span").unwrap();

      /* déplacement autres menus dans menu mobile */
      $(".header-site-content").prepend(
        $(".block-language-selector")
          .clone()
          .attr("id", "block-language-selector-mobile")
      );
      $("#block-menu-main-mobile .level0").append(
        $("#block-menu-shortcuts .level0--item")
          .clone()
          .addClass("with-bg-black with-btn")
      );
      $("#block-menu-main-mobile .level0").append(
        $("#block-menu-secondary .level0--item")
          .clone()
          .addClass("with-bg-black")
      );

      const menu = new MmenuLight(
        document.querySelector("#block-menu-main-mobile"),
        "(max-width: " + (BREAKPOINT_TABLETHOR - 1) + "px)"
      );
      const navigator = menu.navigation({
        title: "",
        theme: "light",
        selected: "active",
      });
      const drawer = menu.offcanvas({
        position: "right",
      });
      $(".btn-menu-mobile").on("click touch", function (e) {
        e.preventDefault();

        if (!$(this).hasClass("active")) {
          drawer.open();
        } else {
          drawer.close();
        }
        $(this).toggleClass("active");
      });
    },

    /**
     * Menu language
     */
    initMenuLanguage: function () {
      $("body").on(
        "mouseover touch focus",
        "#block-language-selector .language-link",
        function (e) {
          e.preventDefault();
          $("#block-language-selector").addClass("open");
        }
      );
      $("body").on(
        "mouseout focusout",
        "#block-language-selector",
        function (e) {
          e.preventDefault();
          $(this).removeClass("open");
        }
      );
    },

    /**
     * Init Header Sticky
     */
    initHeaderSticky: function () {
      this.refreshHeaderSticky();

      $(window).on("scroll", function () {
        var all = Drupal.Theme.load("all");
        all.refreshHeaderSticky();
      });
    },

    refreshHeaderSticky: function () {
      // mobile
      if (
        $(window).outerWidth() <= BREAKPOINT_TABLETHOR &&
        $(window).scrollTop() > 76
      ) {
        $("body").addClass("with-header-sticky");
      }
      // desktop
      else if (
        $(window).outerWidth() > BREAKPOINT_TABLETHOR &&
        $(window).scrollTop() > 50
      ) {
        $("body").addClass("with-header-sticky");
      } else {
        $("body").removeClass("with-header-sticky");
      }
    },

    /**
     * Block Galery
     */
    initBlockGalery: function () {
      if ($(".paragraph--type--container-galery").length) {
        $(".paragraph--type--container-galery").each(function () {
          var glider;
          var self = $(this);

          let buttons = self.find(".glider--wrapper")[0];

          var params = {
            slidesToShow: 1,
            arrows: {
              prev: self.find(".glider-prev")[0],
              next: self.find(".glider-next")[0],
            },
            responsive: [
              {
                // screens greater than >= 576px
                breakpoint: 576,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: "auto",
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 360,
                  exactWidth: true,
                },
              },
            ],
          };

          if (isOverflown(self.find(".galery--content")[0])) {
            if (buttons) {
              buttons.style.display = "flex";
            }
          }

          $(window).resize(function () {
            if (isOverflown(self.find(".galery--content")[0])) {
              glider.updateControls();
              if (buttons) {
                buttons.style.display = "flex";
              }
            } else {
              if (buttons) {
                buttons.style.display = "none";
              }
            }
          });

          if ($(window).outerWidth() < BREAKPOINT_DESKTOP) {
            $(this).find(".galery--content").addClass("carousel");
            glider = new Glider($(this).find(".galery--content")[0]);
            glider.setOption(params);
            glider.updateControls();
            glider.refresh(true);
          }
          $(window).resize(function () {
            if ($(window).outerWidth() < BREAKPOINT_DESKTOP) {
              if (!self.find(".galery--content").hasClass("carousel")) {
                self.find(".galery--content").addClass("carousel");
                glider = new Glider(self.find(".galery--content")[0]);
                glider.setOption(params);
                glider.updateControls();
                glider.refresh(true);
              }
            } else if (
              self.find(".galery--content").hasClass("carousel") &&
              $(window).outerWidth() >= BREAKPOINT_DESKTOP
            ) {
              self.find(".galery--content").removeClass("carousel");
              glider.updateControls();
              glider.refresh(true);
              glider.destroy();
            }
          });
        });
      }
    },

    /**
     * Block Slider
     */
    initBlockSlider: function () {
      var self = this;

      if (self.elements.blockSlider.length) {
        self.elements.blockSlider.each(function () {
          // récup param autoplay
          var autoplayTimeout = 0;
          $(this)
            .attr("class")
            .split(" ")
            .forEach(function (item) {
              if (item.indexOf("autoplay-") >= 0) {
                switch (item.replace("autoplay-", "")) {
                  case "slow":
                    autoplayTimeout = 10000;
                    break;
                  case "fast":
                    autoplayTimeout = 3000;
                    break;
                  case "normal":
                    autoplayTimeout = 5000;
                    break;
                  default:
                    autoplayTimeout = 0;
                }
              }
            });

          // slide video
          $(this).on(
            "click touch",
            ".link-video-embed.open-here",
            function (e) {
              e.preventDefault();

              $(this).addClass("hide");

              // stop autoplay sur le slider
              if (
                $(this)
                  .closest(".block-slider--content")
                  .hasClass("owl-carousel")
              ) {
                $(this)
                  .closest(".block-slider--content")
                  .trigger("stop.owl.autoplay");
              }

              // lecture video
              $(this)
                .closest(".paragraph--type--item-slider-slide")
                .find(".content-video-embed")
                .html(
                  '<iframe src="' +
                    $(this).attr("href") +
                    '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>'
                );
              $(this)
                .closest(".paragraph--type--item-slider-slide")
                .addClass("play-video");
            }
          );

          // init slider
          $(this)
            .find(".block-slider--content")
            .addClass("owl-carousel")
            .owlCarousel({
              loop: true,
              autoplay: autoplayTimeout > 0,
              autoplayTimeout: autoplayTimeout,
              responsiveClass: true,
              autoplayHoverPause: true,
              nav: $(this).hasClass("arrows"),
              navText: [
                '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/frontend/images/sprites.svg#fleche"></use></svg></div>',
                '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/frontend/images/sprites.svg#fleche"></use></svg></div>',
              ],
              dots: $(this).hasClass("dots"),
              autoWidth: false,
              items: 1,
              onChange: function (event) {
                //console.log(event.property.name);
                // si navigation dans slider en pause  suite à une lecture d'une vidéo : restart autoplay et stop vidéo
                if (event.property.name == "position") {
                  // restart autoplay
                  if ($(event.target).autoplay) {
                    $(event.target).trigger("play.owl.autoplay");
                  }

                  // stop video
                  //console.trace($(event.target));
                  $(event.target)
                    .find(".paragraph--type--item-slider-slide")
                    .removeClass("play-video");
                  $(event.target)
                    .find(
                      ".paragraph--type--item-slider-slide .content-video-embed"
                    )
                    .empty();
                  $(event.target)
                    .find(".link-video-embed.hide")
                    .removeClass("hide");
                }
              },
            });
        });
      }
    },

    /**
     * Block Testimonials
     */
    initBlockTestimonials: function () {
      var self = this;

      if (self.elements.blockTestimonials.length) {
        self.elements.blockTestimonials.addClass("owl-carousel").owlCarousel({
          loop: true,
          autoplay: true,
          responsiveClass: true,
          autoplayHoverPause: true,
          nav: true,
          navText: [
            '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/frontend/images/sprites.svg#fleche"></use></svg></div>',
            '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/frontend/images/sprites.svg#fleche"></use></svg></div>',
          ],
          dots: false,
          autoWidth: false,
          items: 1,
        });
      }
    },

    /**
     * Blocks Tabs
     */
    initBlockTabs: function () {
      $(".paragraph--type--container-tabs .field_tabs").each(function () {
        $(this)
          .find(".tab--content")
          .each(function (index) {
            let strClass = "";
            if (index == 0) {
              $(this).addClass("active");
              strClass = 'class="active"';
            }
            let idTab = $(this).attr("id");
            let titleTab = $(this).find(".title-tab").eq(0).text();

            if (
              $(this).closest(".field_tabs").find(".tabs--list").length <= 0
            ) {
              $(this)
                .closest(".field_tabs")
                .prepend('<ul class="tabs--list"></ul>');
            }
            $(this)
              .closest(".field_tabs")
              .find(".tabs--list")
              .append(
                '<li><a href="#' +
                  idTab +
                  '"' +
                  strClass +
                  ' data-title="' +
                  titleTab.replace(/"/g, "&quot;") +
                  '">' +
                  titleTab +
                  "</a></li>"
              );
          });
      });

      $("body").on(
        "click touch",
        ".paragraph--type--container-tabs .tabs--list a",
        function (e) {
          e.preventDefault();

          if ($(this).closest(".tabs--list").find("a.active").length > 0) {
            $(this)
              .closest(".tabs--list")
              .find("a.active")
              .removeClass("active");
          }
          if (
            $(this).closest(".field_tabs").find(".tab--content.active").length >
            0
          ) {
            $(this)
              .closest(".field_tabs")
              .find(".tab--content.active")
              .removeClass("active");
          }

          $(this).addClass("active");

          let idTab = $(this).attr("href");
          $(idTab).addClass("active");
        }
      );

      // mode mobile : slider sur les onglets
      let blocksTabs = $(".paragraph--type--container-tabs .tabs--list");
      let params = {
        loop: false,
        autoplay: false,
        responsiveClass: true,
        nav: true,
        navText: [
          '<div class="owl-btn btn-prev"><span class="sr-only">Précédent</span><svg class="icon"><use xlink:href="/themes/custom/frontend/images/sprites.svg#fleche"></use></svg></div>',
          '<div class="owl-btn btn-next"><span class="sr-only">Suivant</span><svg class="icon"><use xlink:href="/themes/custom/frontend/images/sprites.svg#fleche"></use></svg></div>',
        ],
        dots: false,
        autoWidth: true,
      };

      if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
        blocksTabs.addClass("owl-carousel").owlCarousel(params);
      }
      $(window).resize(function () {
        blocksTabs.each(function () {
          if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
            if (!$(this).hasClass("owl-carousel")) {
              $(this).addClass("owl-carousel").owlCarousel(params);
            }
          } else if ($(this).hasClass("owl-carousel")) {
            $(this).trigger("destroy.owl.carousel").removeClass("owl-carousel");
          }
        });
      });
    },

    /**
     * Block Slider double
     */
    initBlockSliderDouble: function () {
      if ($(".paragraph--type--container-slider-double-photo")[0]) {
        $(".paragraph--type--container-slider-double-photo").each(function () {
          new Glider($(this).find(".paragraph--row")[0], {
            slidesToShow: "1",
            slidesToScroll: "1",
            draggable: true,
            dragVelocity: 10,
            scrollLock: true,
            duration: 0,
            arrows: {
              prev: $(this).find(".glider-prev")[0],
              next: $(this).find(".glider-next")[0],
            },
          });
        });
      }
    },

    /**
     * Block Slider projects
     */
    initBlockSliderProjects: function () {
      if ($(".paragraph--type--container-slider-projects")[0]) {
        $(".paragraph--type--container-slider-projects").each(function () {
          let buttons = $(this).find(".glider--wrapper")[0];

          new Glider($(this).find(".view-list--wrapper")[0], {
            slidesToShow: 1,
            arrows: {
              prev: $(this).find(".glider-prev")[0],
              next: $(this).find(".glider-next")[0],
            },
            responsive: [
              {
                // screens greater than >= 576px
                breakpoint: 576,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: "auto",
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 360,
                  exactWidth: true,
                },
              },
            ],
          });

          // console.log(buttons.length);
          if (buttons) {
            sliderButtonsOverflow(
              $(this).find(".view-list--wrapper")[0],
              buttons
            );
          }
        });
      }
    },

    /**
     * Block Slider Presse
     */
    initBlockSliderPress: function () {
      if ($(".paragraph--type--container-slider-press")[0]) {
        $(".paragraph--type--container-slider-press").each(function () {
          let buttons = $(this).find(".glider--wrapper")[0];

          new Glider($(this).find(".view-list--wrapper")[0], {
            slidesToShow: 1,
            arrows: {
              prev: $(this).find(".glider-prev")[0],
              next: $(this).find(".glider-next")[0],
            },
            responsive: [
              {
                // screens greater than >= 576px
                breakpoint: 576,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: "auto",
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 360,
                  exactWidth: true,
                },
              },
            ],
          });

          // console.log(buttons.length);
          if (buttons) {
            sliderButtonsOverflow(
              $(this).find(".view-list--wrapper")[0],
              buttons
            );
          }
        });
      }
    },


    /**
     * Block Slider Social
     */
    initBlockSliderSocial: function () {
      if ($(".view-display-latest-social")[0]) {
        $(".view-display-latest-social").each(function () {
          let buttons = $(this).find(".glider--wrapper")[0];

          new Glider($(this).find(".view-list--wrapper")[0], {
            slidesToShow: 1,
            arrows: {
              prev: $(this).find(".glider-prev")[0],
              next: $(this).find(".glider-next")[0],
            },
            responsive: [
              {
                // screens greater than >= 576px
                breakpoint: 576,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: 1,
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 318,
                  exactWidth: true,
                },
              },
            ],
          });

          // console.log(buttons.length);
          if (buttons) {
            sliderButtonsOverflow(
              $(this).find(".view-list--wrapper")[0],
              buttons
            );
          }
        });
      }
    },

    /**
     * Block Push simple
     */
    initPushSimple: function () {
      if ($(".paragraph--type--container-push-simple")[0]) {
        $(".paragraph--type--container-push-simple").each(function () {
          let buttons = $(this).find(".glider--wrapper")[0];

          new Glider($(this).find(".paragraph--repeater")[0], {
            arrows: {
              prev: $(this).find(".glider-prev")[0],
              next: $(this).find(".glider-next")[0],
            },
            slidesToShow: "auto",
            slidesToScroll: "auto",
            draggable: true,
            dragVelocity: 10,
            itemWidth: 254,
            // exactWidth: true,
          });

          if (buttons) {
            sliderButtonsOverflow(
              $(this).find(".paragraph--repeater")[0],
              buttons
            );
          }
        });
      }
    },

    /**
     * Block Keynumbers push
     */
    initKeyNumbersPush: function () {
      if ($(".paragraph--type--key-numbers-push")[0]) {
        $(".paragraph--type--key-numbers-push").each(function () {
          let buttons = $(this).find(".glider--wrapper")[0];

          new Glider($(this).find(".paragraph--repeater")[0], {
            arrows: {
              prev: $(this).find(".glider-prev")[0],
              next: $(this).find(".glider-next")[0],
            },
            slidesToShow: "auto",
            slidesToScroll: "auto",
            draggable: true,
            dragVelocity: 10,
            itemWidth: 254,
            // exactWidth: true,
          });

          if (buttons) {
            sliderButtonsOverflow(
              $(this).find(".paragraph--repeater")[0],
              buttons
            );
          }
        });
      }
    },

    /**
     * Block List cards
     */
    initListCards: function () {
      if ($(".paragraph--type--container-cards")[0]) {
        $(".paragraph--type--container-cards.slideractive").each(function () {
          let buttons = $(this).find(".glider--wrapper")[0];
          new Glider($(this).find(".paragraph--row")[0], {
            slidesToShow: 1,
            arrows: {
              prev: $(this).find(".glider-prev")[0],
              next: $(this).find(".glider-next")[0],
            },
            responsive: [
              {
                // screens greater than >= 775px
                breakpoint: 576,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: "auto",
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 360,
                  exactWidth: true,
                },
              },
              {
                // screens greater than >= 775px
                breakpoint: 1001,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: "auto",
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 336,
                  exactWidth: true,
                },
              },
              {
                // screens greater than >= 775px
                breakpoint: 1440,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: "auto",
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 416,
                  exactWidth: true,
                },
              },
            ],
          });

          if (buttons) {
            sliderButtonsOverflow($(this).find(".paragraph--row")[0], buttons);
          }
        });
      }
    },

    /**
     * Block List rse
     */
    initListRse: function () {
      if ($(".paragraph--type--container-rse")[0]) {
        $(".paragraph--type--container-rse").each(function () {
          let buttons = $(this).find(".glider--wrapper")[0];

          new Glider($(this).find(".paragraph--row")[0], {
            slidesToShow: 1,
            arrows: {
              prev: $(this).find(".glider-prev")[0],
              next: $(this).find(".glider-next")[0],
            },
            responsive: [
              {
                // screens greater than >= 775px
                breakpoint: 576,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: "auto",
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 360,
                  exactWidth: true,
                },
              },
              {
                // screens greater than >= 775px
                breakpoint: 1001,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: "auto",
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 336,
                  exactWidth: true,
                },
              },
              {
                // screens greater than >= 775px
                breakpoint: 1439,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: "auto",
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 396,
                  exactWidth: true,
                },
              },
              {
                // screens greater than >= 775px
                breakpoint: 1921,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: "auto",
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 416,
                  exactWidth: true,
                },
              },
            ],
          });

          if (buttons) {
            sliderButtonsOverflow($(this).find(".paragraph--row")[0], buttons);
          }
        });
      }
    },

    /**
     * Block List cards
     */
    initFrise: function () {
      if ($(".paragraph--type--container-simple-cards")[0]) {
        $(".paragraph--type--container-simple-cards").each(function () {
          let buttons = $(this).find(".glider--wrapper")[0];

          new Glider($(this).find(".paragraph--row")[0], {
            slidesToShow: 1,
            arrows: {
              prev: $(this).find(".glider-prev")[0],
              next: $(this).find(".glider-next")[0],
            },
            responsive: [
              {
                // screens greater than >= 576px
                breakpoint: 576,
                settings: {
                  slidesToShow: "auto",
                  slidesToScroll: "auto",
                  draggable: true,
                  dragVelocity: 10,
                  itemWidth: 360,
                  exactWidth: true,
                },
              },
            ],
          });

          if (buttons) {
            sliderButtonsOverflow($(this).find(".paragraph--row")[0], buttons);
          }
        });
      }
    },

    /**
     * Block Reassurance
     */
    initBlockReinssurance: function () {
      // var containerReinssurance = $('.paragraph--type--container-reinssurance .paragraph--row');
      if ($(".paragraph--type--container-reinssurance")[0]) {
        $(".paragraph--type--container-reinssurance").each(function () {
          new Glider($(this).find(".paragraph--row")[0], {
            slidesToShow: "auto",
            slidesToScroll: "auto",
            draggable: true,
            dragVelocity: 10,
          });
        });
      }

      // var params = {
      //   loop: true,
      //   autoplay: true,
      //   responsiveClass: true,
      //   nav: false,
      //   dots: false,
      //   autoWidth: false,
      //   items: 1
      // };
      //
      // if ($(window).outerWidth() < BREAKPOINT_TABLET) {
      //   containerReinssurance.addClass('owl-carousel').owlCarousel(params);
      // }
      // $(window).resize(function() {
      //   if ($(window).outerWidth() < BREAKPOINT_TABLET) {
      //     if (!containerReinssurance.hasClass('owl-carousel')) {
      //       containerReinssurance.addClass('owl-carousel').owlCarousel(params);
      //     }
      //   } else {
      //     if (containerReinssurance.hasClass('owl-carousel')) {
      //       containerReinssurance.trigger('destroy.owl.carousel').removeClass('owl-carousel');
      //     }
      //   }
      // });
    },

    /**
     * Init block Timeline
     */
    initBlockTimeline: function () {
      // init. mode mobile
      if ($(window).outerWidth() <= BREAKPOINT_TABLETHOR) {
        $(".paragraph--type--item-timeline-element:first-child").addClass(
          "active"
        );
      }

      // init. nav
      $("body").on(
        "click touch",
        ".paragraph--type--block-timeline .timeline--previous",
        function (e) {
          e.preventDefault();
          let itemStepActive = $(
            ".paragraph--type--block-timeline .timeline--summary li.active"
          );
          if (itemStepActive.length) {
            let itemPrevious = itemStepActive.prev();
            if (itemPrevious.length) {
              itemPrevious.find("a").click();
            }
          }
        }
      );
      $("body").on(
        "click touch",
        ".paragraph--type--block-timeline .timeline--next",
        function (e) {
          e.preventDefault();
          let itemStepActive = $(
            ".paragraph--type--block-timeline .timeline--summary li.active"
          );
          if (itemStepActive.length) {
            let itemNext = itemStepActive.next();
            if (itemNext.length) {
              itemNext.find("a").click();
            }
          }
        }
      );

      // init. click sur éléments de la timeline
      $("body").on(
        "click touch",
        ".paragraph--type--block-timeline .timeline--summary a",
        function (e) {
          e.preventDefault();

          let target = $(this).attr("href");

          if ($(window).outerWidth() <= BREAKPOINT_TABLETHOR) {
            let all = Drupal.Theme.load("all");
            all.blockTimelineDisplayStep(target, $(this).parent());
          } else {
            let topAnchor =
              $(target).offset().top -
              parseInt($(".header-site").outerHeight());
            $("html, body").stop().animate({ scrollTop: topAnchor }, 400);
          }
        }
      );

      // refresh on scroll
      this.refreshBlockTimeline();
      $(window).on("scroll", function () {
        var all = Drupal.Theme.load("all");
        all.refreshBlockTimeline();
      });
    },

    /**
     * Block Citation Img Push
     */
    initBlockCitationImgPush: function (el) {
      $(".paragraph--type--block-citation-img-push .field_audio").each(
        function () {
          let commandMp3 = $(this).find(".command");
          let urlMp3 = commandMp3.attr("href");
          let infosMp3 = $(this).find(".infos");
          //console.log(urlMp3);
          // chargement du player mp3
          // https://wavesurfer-js.org/docs/
          let wavesurfer = WaveSurfer.create({
            container: $(this).find(".player")[0],
            waveColor: "#c3c8ce",
            progressColor: "#000000",
            cursorColor: "#81bb27",
            cursorWidth: 1.5,
            barWidth: 1.5,
            barRadius: 2,
            //barHeight: 1, // the height of the wave
            barGap: 1.5,
            height: 35,
          });
          wavesurfer.load(urlMp3);

          // actualisation du temps de lecture
          wavesurfer.on("ready", function () {
            let totalSeconds = wavesurfer.getDuration();
            let minutes = Math.floor(totalSeconds / 60);
            let seconds = Math.floor(totalSeconds % 60);
            let duration =
              minutes.toString().padStart(2, "0") +
              ":" +
              seconds.toString().padStart(2, "0");

            infosMp3.html("00:00 sur " + duration);
          });
          wavesurfer.on("audioprocess", function () {
            let totalSeconds = wavesurfer.getDuration();
            let minutes = Math.floor(totalSeconds / 60);
            let seconds = Math.floor(totalSeconds % 60);
            let duration =
              minutes.toString().padStart(2, "0") +
              ":" +
              seconds.toString().padStart(2, "0");

            totalSeconds = wavesurfer.getCurrentTime();
            minutes = Math.floor(totalSeconds / 60);
            seconds = Math.floor(totalSeconds % 60);
            let currentTime =
              minutes.toString().padStart(2, "0") +
              ":" +
              seconds.toString().padStart(2, "0");

            infosMp3.html(currentTime + " sur " + duration);
          });
          wavesurfer.on("finish", function () {
            commandMp3.find(".icon-play").removeClass("hide");
            commandMp3.find(".icon-pause").addClass("hide");
          });
          wavesurfer.on("play", function () {
            commandMp3.find(".icon-play").addClass("hide");
            commandMp3.find(".icon-pause").removeClass("hide");
          });
          wavesurfer.on("pause", function () {
            commandMp3.find(".icon-play").removeClass("hide");
            commandMp3.find(".icon-pause").addClass("hide");
          });

          // bouton play
          $(this)
            .find(".command")
            .on("click touch", function (e) {
              e.preventDefault();
              if (isIos && $(this).data("init") == undefined) {
                // fix iOs : utilisation de la balise audio html5 en créant un élément audio temporaire lors du chargement de la page qui lit un événement de fichier audio silencieux d'une durée de 1 seconde
                let audioios = document.createElement("audio");
                audioios.id = "audio-player-iosfix";
                audioios.src =
                  "data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU2LjM2LjEwMAAAAAAAAAAAAAAA//OEAAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAAEAAABIADAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV6urq6urq6urq6urq6urq6urq6urq6urq6v////////////////////////////////8AAAAATGF2YzU2LjQxAAAAAAAAAAAAAAAAJAAAAAAAAAAAASDs90hvAAAAAAAAAAAAAAAAAAAA//MUZAAAAAGkAAAAAAAAA0gAAAAATEFN//MUZAMAAAGkAAAAAAAAA0gAAAAARTMu//MUZAYAAAGkAAAAAAAAA0gAAAAAOTku//MUZAkAAAGkAAAAAAAAA0gAAAAANVVV";
                audioios.type = "audio/mpeg";
                audioios.play();
                audioios.remove();
                $(this).data("init", "ok");

                setTimeout(function () {
                  wavesurfer.play();
                }, 1000);
              } else {
                wavesurfer.playPause();
              }
            });
        }
      );
    },

    /**
     * Refresh block Timeline
     */
    refreshBlockTimeline: function () {
      let all = Drupal.Theme.load("all");
      let idStepVisible = "";
      let itemStepActive = null;

      if ($(window).outerWidth() > BREAKPOINT_TABLETHOR) {
        //$($('.paragraph--type--block-timeline .timeline--summary li').get().reverse()).each(function () {
        $(".paragraph--type--block-timeline .timeline--summary li").each(
          function () {
            let idStep = $(this).find("a").attr("href");
            let deltaTop = 0; //parseInt($('.header-site').outerWidth());

            if ($(idStep).length) {
              if (all.isScrolledIntoView($(idStep), deltaTop)) {
                //console.log(idStep + ' is visible')
                idStepVisible = idStep;
                itemStepActive = $(this);
              }
            }
          }
        );
      }

      if (idStepVisible != "" && itemStepActive != null) {
        //console.log(idStepVisible + ' is active')
        this.blockTimelineDisplayStep(idStepVisible, itemStepActive);
      }
    },

    blockTimelineDisplayStep: function (idStepVisible, itemStepActive) {
      if (!itemStepActive.hasClass("active")) {
        $(".paragraph--type--block-timeline .timeline--summary li").removeClass(
          "active"
        );
        itemStepActive.addClass("active");

        $(".paragraph--type--item-timeline-element").removeClass("active");
        $(idStepVisible).addClass("active");

        let translateY = parseInt(
          $(".timeline--summary--wrapper ul").offset().top -
            itemStepActive.offset().top
        );
        //console.log(translateY);
        if (translateY == 0) {
          $(".timeline--summary--wrapper ul").css("transform", "none");
        } else {
          $(".timeline--summary--wrapper ul").css(
            "transform",
            "translateY(" + translateY + "px)"
          );
        }

        // refresh nav
        if (itemStepActive.prev().length <= 0) {
          $(".paragraph--type--block-timeline .timeline--previous").attr(
            "disabled",
            "disabled"
          );
        } else {
          $(".paragraph--type--block-timeline .timeline--previous").removeAttr(
            "disabled"
          );
        }
        if (itemStepActive.next().length <= 0) {
          $(".paragraph--type--block-timeline .timeline--next").attr(
            "disabled",
            "disabled"
          );
        } else {
          $(".paragraph--type--block-timeline .timeline--next").removeAttr(
            "disabled"
          );
        }
      }
    },

    /**
     * Page List Projects
     */
    initPageListProjects: function (el) {
      // modif rendu des critères de recherche
      if ($(".view-display-list-projects").length > 0) {
        $(
          ".view-display-list-projects .views-exposed-form .fieldgroup legend"
        ).attr("tabindex", 0);
        $("body").on(
          "click touch",
          ".view-display-list-projects .views-exposed-form .fieldgroup legend",
          function (e) {
            e.preventDefault();
            $(this).closest(".fieldgroup").addClass("selected");
            $(
              ".view-display-list-projects .views-exposed-form .fieldgroup:not(.selected)"
            ).removeClass("active");
            $(this)
              .closest(".fieldgroup")
              .toggleClass("active")
              .removeClass("selected");
          }
        );
        $("body").on(
          "keypress",
          ".view-display-list-projects .views-exposed-form .fieldgroup legend",
          function (e) {
            if (e.which == 13) {
              e.preventDefault();
              $(this).click();
            }
          }
        );
        $("body").on("click touch", function (e) {
          if (!e.target.closest(".fieldgroup")) {
            if (
              $(
                ".view-display-list-projects .views-exposed-form .fieldgroup.active"
              ).length
            ) {
              $(
                ".view-display-list-projects .views-exposed-form .fieldgroup.active"
              ).removeClass("active");
            }
          }
        });


        function checkBox (){
          var inputs = document.querySelectorAll(".form-item-field-fondation-value input");

          // check si inputs sont cochés
          var isChecked = inputs[0].checked;

          if (isChecked) {
            // masque la div avec data-drupal-selector="edit-solution"
            document.querySelector(".view-display-list-projects .views-exposed-form .fieldgroup[data-drupal-selector='edit-solution']").style.display = "none";

            // affiche la div avec data-drupal-selector="edit-field-mission-target-id"
            document.querySelector(".view-display-list-projects .views-exposed-form .fieldgroup[data-drupal-selector='edit-field-mission-target-id']").style.display = "block";

          } else if (!isChecked) {
            // affiche la div avec data-drupal-selector="edit-solution"
            document.querySelector(".view-display-list-projects .views-exposed-form .fieldgroup[data-drupal-selector='edit-solution']").style.display = "block";

            // masque la div avec data-drupal-selector="edit-field-mission-target-id"
            document.querySelector(".view-display-list-projects .views-exposed-form .fieldgroup[data-drupal-selector='edit-field-mission-target-id']").style.display = "none";
          }
        }

        checkBox();

        Drupal.behaviors.betterExposedFilters = {
          attach: function (context, settings) {
            $(document).ajaxComplete(function (event, jqXHR, settings) {
              checkBox();
            });
          }
        };

        Drupal.behaviors.dynamicFilterLabel = {
          attach: function (context, settings) {
            const filterElement = $('fieldset[data-drupal-selector="edit-field-fondation-value"] input:radio[checked="checked"]', context); // Champ select
            const labelElement = $('fieldset[data-drupal-selector="edit-field-fondation-value"] .fieldset-legend', context); // Label associé

            // Mettez à jour le label au chargement de la page.
            updateLabel(filterElement, labelElement);

            // Mettez à jour le label quand la valeur change.
            filterElement.on('change', function () {
              updateLabel(filterElement, labelElement);
            });

            function updateLabel(filterElement, labelElement) {
              const value = filterElement.siblings().text(); // Récupère la valeur sélectionnée
              labelElement.text(value);
            }
          }
        };
      }
    },

    /**
     * Page List Jobs
     */
    initPageListJobs: function (el) {
      // modif rendu des critères de recherche
      if ($(".view-display-list-job-offers").length > 0) {
        $(
          ".view-display-list-job-offers .views-exposed-form .fieldgroup legend"
        ).attr("tabindex", 0);
        $("body").on(
          "click touch",
          ".view-display-list-job-offers .views-exposed-form .fieldgroup legend",
          function (e) {
            e.preventDefault();
            $(this).closest(".fieldgroup").addClass("selected");
            $(
              ".view-display-list-job-offers .views-exposed-form .fieldgroup:not(.selected)"
            ).removeClass("active");
            $(this)
              .closest(".fieldgroup")
              .toggleClass("active")
              .removeClass("selected");
          }
        );
        $("body").on(
          "keypress",
          ".view-display-list-job-offers .views-exposed-form .fieldgroup legend",
          function (e) {
            if (e.which == 13) {
              e.preventDefault();
              $(this).click();
            }
          }
        );
        $("body").on("click touch", function (e) {
          if (!e.target.closest(".fieldgroup")) {
            if (
              $(
                ".view-display-list-job-offers .views-exposed-form .fieldgroup.active"
              ).length
            ) {
              $(
                ".view-display-list-job-offers .views-exposed-form .fieldgroup.active"
              ).removeClass("active");
            }
          }
        });
      }

      // ajout appel ajax sur les résultats de la liste
      $("body").on(
        "click touch",
        ".view-display-list-job-offers .node--type--job-offer.node--view-mode--teaser",
        function (e) {
          e.preventDefault();

          $('.view-display-list-job-offers .view-item').removeClass('active');
          $(this).closest('.view-item').addClass('active');

          Drupal.Theme = new Theme.Common();
          // affichage progress bar
          $("body").after(Drupal.theme.ajaxProgressIndicatorFullscreen());
          var idJobOffer = $(this).data("id");

          $(".view-row-selected").load("/job_offer/" + idJobOffer, function () {
            // supp. progress bar
            $(".ajax-progress-fullscreen").remove();

            // load images lazy
            Drupal.Theme.load("all").initLazyLoad();

            // en mode mobile affichage de la fiche à la place de la liste
            if ($(window).outerWidth() < BREAKPOINT_LAPTOP) {
              $(".header-site").removeClass("with-text-white");
              $(".content-page-header").hide();
              $(".view-display-list-job-offers .views-exposed-form").hide();
              $(".view-display-list-job-offers .view-result").hide();
              $(
                ".view-display-list-job-offers .btn-back-to-list-job-offer"
              ).css("display", "inline-flex");
              $(".view-display-list-job-offers .view-row-selected").show();
              $(".view-display-list-job-offers .view-row-selected").css(
                "padding-top",
                "90px"
              );
              window.scrollTo(0, 0);

              $("body").on(
                "click touch",
                ".view-display-list-job-offers .btn-back-to-list-job-offer",
                function (e) {
                  e.preventDefault();

                  $(".header-site").addClass("with-text-white");
                  $(".content-page-header").show();
                  $(".view-display-list-job-offers .views-exposed-form").show();
                  $(".view-display-list-job-offers .view-result").show();
                  $(
                    ".view-display-list-job-offers .btn-back-to-list-job-offer"
                  ).hide();
                  $(".view-display-list-job-offers .view-row-selected").hide();
                  var topAnchor =
                    parseInt(
                      $(
                        ".node--type--job-offer.node--view-mode--teaser[data-id='" +
                          idJobOffer +
                          "']"
                      ).offset().top
                    ) - 130;
                  window.scrollTo(0, topAnchor);
                }
              );
            }
          });

          document.title = $(this).find(".title").text() + " | Akena Corporate";
          window.history.pushState(
            { pageTitle: document.pageTitle },
            "",
            $(this).attr("href")
          );
        }
      );
    },

    /**
     * Page List Press
     */
    initPageListPress: function (el) {
      // modif rendu des critères de recherche
      if ($(".view-display-list-press").length > 0) {
        $(
          ".view-display-list-press .views-exposed-form .fieldgroup legend"
        ).attr("tabindex", 0);
        $("body").on(
          "click touch",
          ".view-display-list-press .views-exposed-form .fieldgroup legend",
          function (e) {
            e.preventDefault();
            $(this).closest(".fieldgroup").addClass("selected");
            $(
              ".view-display-list-press .views-exposed-form .fieldgroup:not(.selected)"
            ).removeClass("active");
            $(this)
              .closest(".fieldgroup")
              .toggleClass("active")
              .removeClass("selected");
          }
        );
        $("body").on(
          "keypress",
          ".view-display-list-press .views-exposed-form .fieldgroup legend",
          function (e) {
            if (e.which == 13) {
              e.preventDefault();
              $(this).click();
            }
          }
        );
        $("body").on("click touch", function (e) {
          if (!e.target.closest(".fieldgroup")) {
            if (
              $(
                ".view-display-list-press .views-exposed-form .fieldgroup.active"
              ).length
            ) {
              $(
                ".view-display-list-press .views-exposed-form .fieldgroup.active"
              ).removeClass("active");
            }
          }
        });
      }
    },

    /**
     * Blocks Sliders for mobile
     */
    initSlidersForMobile: function (el) {
      var containerBlocks = $(el);
      var params = {
        loop: true,
        autoplay: false,
        responsiveClass: true,
        nav: false,
        dots: false,
        autoWidth: false,
        items: 1.2,
        margin: 25,
      };

      if ($(window).outerWidth() < BREAKPOINT_TABLET) {
        containerBlocks.addClass("owl-carousel").owlCarousel(params);
      }
      $(window).resize(function () {
        if ($(window).outerWidth() < BREAKPOINT_TABLET) {
          if (!containerBlocks.hasClass("owl-carousel")) {
            containerBlocks.addClass("owl-carousel").owlCarousel(params);
          }
        } else if (containerBlocks.hasClass("owl-carousel")) {
          containerBlocks
            .trigger("destroy.owl.carousel")
            .removeClass("owl-carousel");
        }
      });
    },

    /**
     * Block FAQ
     */
    initBlockFaq: function () {
      $("body").on(
        "click touch",
        ".paragraph--type--block-faq .field_question",
        function (e) {
          e.preventDefault();
          $(this).addClass("selected");
          $(this)
            .closest(".paragraph--type--block-faq")
            .find(".field_question:not(.selected)")
            .removeClass("active");
          $(this).removeClass("selected").toggleClass("active");
        }
      );
    },

    /**
     * Block FAQ
     */
    initBlockWebform: function () {
      $("body").on(
        "click touch",
        ".paragraph--type--container-webform .webform-wrap .btn",
        function (e) {
          e.preventDefault();
          $(".webform-submission-contact-form").toggleClass("active");
        }
      );
    },

    /**
     * Block video
     */
    initBlockVideo: function () {
      $('.paragraph--type--container-video').each(function() {
        $(this).find('.paragraph--type--item-container-header').prependTo($(this).find('.block-video-embed--inner'));
        $(this).find('.paragraph--type--item-container-footer').appendTo($(this).find('.block-video-embed--inner'));
      });

      $('body').on('click touch', '.paragraph--type--block-video-embed .block-video-embed--link.open-here', function (e) {
        e.preventDefault();
        // $(this).closest('.paragraph--type--block-video-embed').find('.block-video-embed--content').html('<iframe src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen="1" allow="autoplay; fullscreen; encrypted-media"></iframe>');
        $(this).closest('.paragraph--type--block-video-embed').addClass('play');
      });
    },

    /**
     * Contextual links
     */
    initContextualLinks: function () {
      // items
      var strContextualLinks = "";
      $(".paragraph-root").each(function () {
        if ($(this).attr("id") && $(this).attr("data-label"))
          strContextualLinks +=
            '<li><a href="#' +
            $(this).attr("id") +
            '" id="contextual-link--' +
            $(this).attr("id") +
            '">' +
            $(this).attr("data-label") +
            "</a></li>";
      });
      if (strContextualLinks != "") {
        $(".field_reference").prepend(
          '<div class="contextual-menu"><div class="contextual-menu--wrapper"><ul>' +
            strContextualLinks +
            "</ul></div></div>"
        );

        //$('.contextual-menu').attr('data-init-offset-top', $('.contextual-menu').offset().top);
        //$('.contextual-menu').attr('data-init-height', $('.contextual-menu--wrapper').outerHeight());

        $(".contextual-menu .contextual-menu--wrapper").on(
          "click touch",
          function (e) {
            e.preventDefault();

            if ($(window).outerWidth() < BREAKPOINT_TABLET) {
              $(this).closest(".contextual-menu").toggleClass("collapsed");
            }
          }
        );
        $(".contextual-menu .contextual-menu--wrapper a").on(
          "click touch",
          function (e) {
            e.preventDefault();

            if (!$(this).closest("li").hasClass("active")) {
              var target = $(this).attr("href");
              //var topAnchor = $(target).offset().top - parseInt($('.header-site').outerHeight()) - parseInt($('.contextual-menu').attr('data-init-height'));
              //var topAnchor = $(target).offset().top - parseInt($('.header-site--wrapper').outerHeight()) - parseInt($('.contextual-menu--wrapper').outerHeight());
              var topAnchor =
                $(target).offset().top -
                parseInt($(".contextual-menu--wrapper").outerHeight());

              $("html, body").stop().animate({ scrollTop: topAnchor }, 400);
            }
          }
        );

        // refresh
        this.refreshContextualLinks();

        $(window).on("scroll", function () {
          var all = Drupal.Theme.load("all");
          all.refreshContextualLinks();
        });
      }
    },

    /**
     * refreshContextualLinks
     */
    refreshContextualLinks: function () {
      var all = Drupal.Theme.load("all");
      var menuContextualTop = $(".contextual-menu").offset().top; //$('.contextual-menu').attr('data-init-offset-top');
      var menuContextualHeight = $(".contextual-menu--wrapper").outerHeight(); //$('.contextual-menu').attr('data-init-height');

      // items
      /*console.log($(window).scrollTop() + '+' + $('.header-site').outerHeight());
      console.log($('.contextual-menu').offset().top);
      console.log(($(window).scrollTop() + $('.header-site').outerHeight()) +'>='+ menuContextualTop);*/

      //if (($(window).scrollTop() + $('.header-site--wrapper').outerHeight()) >= menuContextualTop) {
      if ($(window).scrollTop() >= menuContextualTop) {
        $(".contextual-menu").css("height", menuContextualHeight);
        //$('.contextual-menu--wrapper').css('top', $('.header-site--wrapper').outerHeight());
        $(".contextual-menu--wrapper").css("top", "0");
        $("body").addClass("contextual-menu-sticky");
      } else {
        $(".contextual-menu").css("height", "auto");
        $(".contextual-menu--wrapper").css("top", "auto");
        $("body").removeClass("contextual-menu-sticky");
      }

      //var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu').attr('data-init-height'));
      //var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu--wrapper').outerHeight());
      //var deltaTop = parseInt($('.contextual-menu--wrapper').outerHeight());
      var activeLink = "";
      var links = $(".contextual-menu .contextual-menu--wrapper a")
        .get()
        .reverse();
      $(links).each(function () {
        var idLink = "#" + $(this).attr("id");
        var paragRoot = $(idLink.replace("contextual-link--", "")).closest(
          ".paragraph-root"
        );

        if (all.isScrolledIntoView(paragRoot, deltaTop)) {
          activeLink = idLink;
        }
      });

      if (activeLink != "") {
        $(".contextual-menu .contextual-menu--wrapper li.active").removeClass(
          "active"
        );
        $(activeLink).closest("li").addClass("active");
      }
    },

    initForm: function () {
      // labels
      $(".form-text, .form-email")
        .each(function () {
          if ($(this).val() != "") {
            $(this).closest(".form-item").addClass("active");
          }
        })
        .focus(function (e) {
          e.preventDefault();
          $(this).closest(".form-item").addClass("active");
        })
        .blur(function (e) {
          e.preventDefault();
          if ($(this).val() == "") {
            $(this).closest(".form-item").removeClass("active");
          }
        });

      $(".form-select")
        .each(function () {
          if ($(this).val() != "") {
            $(this).closest(".form-item").addClass("active");
          }
        })
        .change(function (e) {
          e.preventDefault();
          if ($(this).val() == "") {
            $(this).closest(".form-item").removeClass("active");
          } else {
            $(this).closest(".form-item").addClass("active");
          }
        });

      // form-checkboxes
      $(".views-exposed-form .form-checkboxes").each(function () {
        let fieldLegend = $(this)
          .closest(".fieldgroup")
          .find(".fieldset-legend");
        if (fieldLegend.data("label") == undefined) {
          fieldLegend.data("label", fieldLegend.text());
        }
        let labelsSelected = "";
        $(this)
          .find(".form-checkbox[checked='checked']")
          .each(function () {
            labelsSelected +=
              (labelsSelected != "" ? ", " : "") +
              $(this).closest(".form-control").find(".option").text();
          });
        if (labelsSelected == "") {
          labelsSelected = fieldLegend.data("label");
          $(this).closest(".fieldgroup").removeClass("with-item-selected");
        } else {
          $(this).closest(".fieldgroup").addClass("with-item-selected");
        }
        fieldLegend.html(labelsSelected);
      });
    },

    /**
     * isScrolledIntoView
     */
    isScrolledIntoView: function (elem, deltaTop) {
      var win = $(window);
      var viewport = {
        top: win.scrollTop() + deltaTop,
        left: win.scrollLeft(),
      };
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height() - deltaTop;

      var bounds = elem.offset();
      bounds.right = bounds.left + elem.outerWidth();
      bounds.bottom = bounds.top + elem.outerHeight();

      //var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu').attr('data-init-height'));
      //var deltaTop = parseInt($('.header-site--wrapper').outerHeight()) + parseInt($('.contextual-menu--wrapper').outerHeight());
      //var deltaTop = parseInt($('.contextual-menu--wrapper').outerHeight());

      //console.log(elem.prop("id"));
      //console.log("top:" + (viewport.top + deltaTop) + ">" + bounds.bottom);
      //console.log("bottom:" + (viewport.bottom + "<" + bounds.top + win.height() / 4));

      return !(
        viewport.right < bounds.left ||
        viewport.left > bounds.right ||
        viewport.bottom < bounds.top + win.height() / 4 ||
        viewport.top + deltaTop > bounds.bottom
      );
    },

    /**
     * initEffectsOnScroll  (optionnel)
     * Requiert scrollreveal : à activer dans site.json ("./node_modules/scrollreveal/dist/scrollreveal.min.js")
     */
    /*initEffectsOnScroll: function (){
      var optionReset = false;
      var optionDelay = 200;
      var options;
      var delai;

      // animation des titres
      options = { reset: optionReset, delay: 0, duration: 800, distance: '50px', origin: 'left', opacity: 0, interval: 150 };
      ScrollReveal().reveal(
          '.effects-enabled .content-page-header--wrapper .title1, ' +
          '.effects-enabled .content-page-header--wrapper .field_header_text',
          options
      );
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0 };
      ScrollReveal().reveal('.effects-enabled .paragraph--type--item-container-header', options);

      // animation des chiffres
      options = {reset: optionReset, delay: 0, duration: 600, origin: 'bottom', opacity: 0,
          afterReveal: function (el) {
              var all = Drupal.Theme.load('all');
              all.animateNumber($(el));
          }
      };
      ScrollReveal().reveal('.effects-enabled .wysiwyg .numerator', options);

      // animation des icônes réseaux sociaux du footer
      options = {reset: optionReset, delay: optionDelay, duration: 1000, origin: 'bottom', opacity: 0, scale: 1.5 };
      ScrollReveal().reveal($('.effects-enabled').closest('body').find('#block-menu-social-media .level0--item'), options);

      // animation des cards se trouvant dans des vues
      options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
      ScrollReveal().reveal($('.effects-enabled .views-element-container .view-list--wrapper > .view-item'), options);

      // animation des questions de la faq
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'right', opacity: 0, interval: 200 };
      ScrollReveal().reveal($('.effects-enabled .paragraph--type--block-faq .field_question'), options);

      // animation pour les boutons
      options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 100 };
      ScrollReveal().reveal($('.effects-enabled .paragraph-root .btn, .paragraph-root .button'), options);

      // animation paragraphe citation
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0, scale: 1.5, interval: 200 };
      ScrollReveal().reveal(
          $('.effects-enabled .paragraph--type--block-citation .field_sentence'),
          options
      );
      options = { reset: optionReset, delay: optionDelay, duration: 800, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
      ScrollReveal().reveal(
          $('.effects-enabled .paragraph--type--block-citation .field_author, ' +
              '.effects-enabled .paragraph--type--block-citation .field_author_title'),
          options
      );

      // animation alternée des paragraphes roots
      var cptParagraphRoot = 0;
      $('.effects-enabled .paragraph-root').each(function (index) {

          // animation pour paragraphe de type "2 colonnes"
          if ($(this).hasClass('paragraph--type--container-2col') ||
              $(this).hasClass('paragraph--type--container-2wysiwyg') ||
              $(this).hasClass('paragraph--type--container-faq') ||
              $(this).hasClass('paragraph--type--container-image-text') ||
              $(this).hasClass('paragraph--type--container-video-text')) {

              // sous paragraphes
              $(this).find('.paragraph--row > *').each(function (index) {
                  if ($(this).closest('.paragraph-root').hasClass('display-rtl')) {
                      var origin = (index % 2 == 0 ? 'right' : 'left');
                  }
                  else {
                      var origin = (index % 2 == 0 ? 'left' : 'right');
                  }
                  options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                  ScrollReveal().reveal($(this), options);
              });
          }
          // animation pour paragraphe contenant des cards
          else if ($(this).hasClass('paragraph--type--container-3col') ||
              $(this).hasClass('paragraph--type--container-4col') ||
              $(this).hasClass('paragraph--type--container-reinssurance') ||
              $(this).hasClass('paragraph--type--container-content-custom')) {
              options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
              ScrollReveal().reveal($(this).find('.paragraph--row .paragraph--type--block-card'), options);
          }

          // animation pour paragraphe chronologie
          else if ($(this).hasClass('paragraph--type--container-chronology')) {
              // sous paragraphes
              $(this).find('.chronology--item-text').each(function (index) {
                  var origin = (index % 2 == 0 ? 'left' : 'right');
                  options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                  ScrollReveal().reveal($(this), options);
              });
          }

          // animation pour paragraphe galery
          else if ($(this).hasClass('paragraph--type--container-galery')) {
              options = { reset: optionReset, delay: optionDelay, duration: 600, origin: 'bottom', opacity: 0, scale: 0.5, interval: 200 };
              ScrollReveal().reveal($(this).find('.paragraph--type--block-image'), options);
          }
          // animations pour paragraphes de type "multilignes"
          else if ($(this).hasClass('paragraph--type--container-col2-texts')) {
              cptParagraphRoot++;

              // sous paragraphes
              $(this).find('.container-col2-texts--content > li').each(function (index) {
                  var origin = (index % 2 == 0 ? 'right' : 'left');
                  options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
                  ScrollReveal().reveal($(this), options);
              });
          }
          // animation pour autres paragraphes
          else if (!$(this).hasClass('paragraph--type--container-wysiwyg') &&
              !$(this).hasClass('paragraph--type--container-citation') &&
              !$(this).hasClass('paragraph--type--container-webform')) {
              cptParagraphRoot++;

              var origin = (index % 2 == 0 ? 'right' : 'left');
              options = { reset: optionReset, delay: optionDelay, duration: 800, distance: '200px', origin: origin, opacity: 0 };
              ScrollReveal().reveal($(this), options);
          }
      });
    },*/
};
})(jQuery, Drupal, drupalSettings);
